import * as React from 'react';
import { AnchorListItem } from '@pec/aion-ui-components/components/Nav/AnchorListItem';
import { ToDoDescriptor } from '../types';
import { Typography } from '@material-ui/core';
import { useToDoStyles } from '../styles';

type Props = {
  descriptor: ToDoDescriptor;
};

export const ToDoLinkItem: React.FC<Props> = ({ descriptor }) => {
  const classes = useToDoStyles();
  const { id, label, icon, href, count } = descriptor;
  const styledIcon = React.cloneElement(icon, { classes: { root: classes.icon } });

  return (
    <AnchorListItem key={id} icon={styledIcon} href={href} style={{ paddingLeft: 0 }}>
      <Typography variant="body1" color="primary">
        {count !== undefined ? `${label} (${count})` : label}
      </Typography>
    </AnchorListItem>
  );
};
